// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","459":"6e8d85aa"}[chunkId] || chunkId) + "-" + {"293":"8905ebd6b68bab2cb40c","459":"013831dc2701d11946e2","522":"926b8d52cba8ff21e26d"}[chunkId] + ".js";
};